import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { LocalStorageKeys } from '../constants/locationStorage';

export const SharedProfileEntry: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();
  const { username, sharedHandle } = useParams<{
    username?: string;
    sharedHandle?: string;
  }>();
  const rawHandle = sharedHandle ?? username ?? '';
  const normalizedUsername = rawHandle.replace(/^@+/, '');

  if (isLoading) {
    return null;
  }

  if (!normalizedUsername) {
    return <Navigate to="/login" replace />;
  }

  const returnTo =
    location.pathname + location.search + location.hash || `/cb/@${normalizedUsername}`;

  if (!isAuthenticated) {
    localStorage.setItem(LocalStorageKeys.POST_LOGIN_REDIRECT, returnTo);
    return (
      <Navigate
        to={`/login?returnTo=${encodeURIComponent(returnTo)}`}
        replace
      />
    );
  }

  // Route into your existing protected profile experience
  // We'll make ProfilePage understand /profile/@username
  return <Navigate to={`/profile/@${normalizedUsername}`} replace />;
};
